module.exports = __webpack_public_path__ + "static/media/download.adbd2b1c.svg";